import { render } from "./sales-details.vue?vue&type=template&id=66d3f3ab&scoped=true"
import script from "./sales-details.vue?vue&type=script&lang=js"
export * from "./sales-details.vue?vue&type=script&lang=js"

import "./sales-details.vue?vue&type=style&index=0&id=66d3f3ab&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d3f3ab"]])

export default __exports__